import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const ProjectsDocumentation = (props) => { 
    return (
        <div>
          <p>
            Songs are organized as projects on Zequencer. They can be saved, loaded and shared with people
            in a variety of ways.
          </p>
          <p>
            In order to take advantage of this, either login to your account or sign up for an account at the top-right of this screen.
          </p>
          <p className="sub-header">
            Saving Projects
          </p>
          <p>
            To save a project, click the <b>save button</b> at the top right of the project's screen. This
            will bring up a pop-up.
          </p>
          <p>
            If you are logged in, you will be asked to type a name for your project. 
          </p>
          <p>
            By default, projects that are only accessible by you. You can add collaborators
            to the track by typing in their user name in the popup. 
          </p>
          <p>
            Click the <b>Public</b> checkbox to allow anyone to view or edit your project. Your project will appear
            in everyone projects list, when saved as <b>Public</b>.
          </p>
          <p className="sub-header">
            Version Control
          </p>
          <p>
            Projects can never be overwritten. Whenever you make an edit to a project, and then save it, it will save
            a version of the project. The original project will remain intact. This allows you
            to go back to previous saved-versions of a project.
          </p>
          <p>
            For projects where multiple people edit the same project, each persons edit will show up as a seperate project.
          </p>
          <p className="sub-header">
            Loading Projects
          </p>
          <p>
            To view all projects, expand the sidebar and click the <b>Projects</b> tab. This will show a list
            of every project ever.
          </p>
          <p>
            To load a project, click on the circle to the left of the project you wish to load.
          </p>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsDocumentation);
